import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://twjfbkymnzfvmftncuyb.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3amZia3ltbnpmdm1mdG5jdXliIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTQ2OTY3OTMsImV4cCI6MjAzMDI3Mjc5M30.v7jI9CyxDt6nKl6Ho03aFrMP8ajHWI97CBvdM-igcQ0";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
